/* eslint-disable import/prefer-default-export */
import { CHANGE_FORM } from '../constants';

export default newState => ({
  type: CHANGE_FORM,
  newState
});



// WEBPACK FOOTER //
// ./src/actions/changeForm.js